




























































































































import Vue from 'vue'
import Component from 'vue-class-component'
import Carousel from '@/components/Carousel.vue'
import PaymentMethodModal from '@/components/modals/PaymentMethodModal.vue'
import CreditCard from '@/components/CreditCard.vue'
import ECheckCard from '@/components/eCheckCard.vue'
import { EPaymentMethodType, EUserPermissions, EUserType, IFacility, IResidentPaymentMethod } from '@zunta/configurations'
import { ResidentModule } from '@/store/modules/resident.module'
import { getModule } from 'vuex-module-decorators'
import Confirm from '@/components/Confirm.vue'
import Checkbox from '@/components/inputsV2/Checkbox.vue'
import { FacilityModule } from '@/store/modules/facility.module'
import RadioGroup from '@/components/RadioGroup.vue'
import Icon from '@/components/Icon.vue'
import { User } from '@/classes/User'
import Api from '@/api'
import Card from '@/components/Card.vue'
// @ts-ignore
import ClickOutside from 'vue-click-outside'
import { Watch } from 'vue-property-decorator'

@Component({
  name: 'PaymentMethods',
  components: {
    Card,
    Icon,
    RadioGroup,
    Checkbox,
    ECheckCard,
    CreditCard,
    Carousel,
    PaymentMethodModal,
    Confirm
  },
  props: {
    simpleView: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Number,
      default: 0
    }
  },
  directives: {
    ClickOutside
  }
})
export default class PaymentMethods extends Vue {
  residentModuleInstance: ResidentModule = getModule(ResidentModule, this.$store)
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store)
  user: User = Api.getUser() as User
  EUserPermissions: any = EUserPermissions
  EPaymentMethodType: any = EPaymentMethodType
  editPaymentData: IResidentPaymentMethod | null = null
  wantAddPaymentMethod: boolean = false
  deleteErrorMessage: string = ''
  selectedCard: number = 0
  showActions: number = -1

  get residentId () {
    return this.$route.params.residentId
  }

  get resident () {
    return this.$store.state.resident
  }

  get ccDisabled () {
    const selectedResident = this.resident.selectedResident
    const facility = (selectedResident.facility as IFacility)
    const isDisabled = !facility || !facility.allowCCProcessing ||
     (this.user.data.type === EUserType.RESIDENT && facility.isResidentPortalNoCC)
    return isDisabled
  }

  get paymentMethods (): IResidentPaymentMethod[] {
    let methods = this.resident.paymentMethods
    if (this.ccDisabled) {
      methods = (this.resident.paymentMethods as IResidentPaymentMethod[]).filter(m =>
        m.type !== EPaymentMethodType.CREDIT_CARD
      )
    }
    methods.sort((x: any, y: any) => (x.isPrimary === y.isPrimary) ? 0 : x.isPrimary ? -1 : 1)
    return methods
  }

  get carouselSize () {
    return window.innerWidth < 1150 ? 1 : 2
  }

  get paymentMethodsOptions () {
    return this.paymentMethods.map(method => {
      const methodContent =
        method.type === EPaymentMethodType.CREDIT_CARD
          ? `CC ****${method.last4Digits}`
          : `ECheck ****${method.last4Digits}`
      return {
        value: method.id,
        content: methodContent,
        key: method.id
      }
    })
  }

  get ccPaymentMethods () {
    return this.paymentMethods.filter((paymentMethod: IResidentPaymentMethod) => {
      return paymentMethod.type === EPaymentMethodType.CREDIT_CARD
    })
  }

  get eCheckPaymentMethods () {
    return this.paymentMethods.filter((paymentMethod: IResidentPaymentMethod) => {
      return paymentMethod.type === EPaymentMethodType.ECHECK
    })
  }

  get hasPaymentMethods () {
    return this.paymentMethods.length > 0
  }

  @Watch('paymentMethodsOptions')
  setSelectedPaymentMethodIfOnlyOne () {
    if (this.paymentMethodsOptions && this.paymentMethodsOptions.length === 1) {
      const pmethodId = this.paymentMethodsOptions[0].value
      const paymentMethod = this.paymentMethods && this.paymentMethods.find(pm => pm.id === pmethodId)
      this.selectPaymentMethod(paymentMethod || 0)
    }
  }

  @Watch('paymentMethods')
  setSelectedPaymentMethodByPrimary () {
    this.paymentMethods.forEach((pm: IResidentPaymentMethod) => {
      if (pm.isPrimary) {
        this.selectedCard = pm.id
        this.selectPaymentMethod(pm)
      }
    })
  }

  mounted () {
    this.setSelectedPaymentMethodByPrimary()
    if (this.$props.selected && !this.paymentMethods.find((pm: IResidentPaymentMethod) => pm.id === this.$props.selected)) {
      this.selectPaymentMethod(0)
    }
  }

  setCloseOptionsList () {
    this.setOpenOptionsList(-1)
  }

  setOpenOptionsList (value: number) {
    this.showActions = value
  }

  selectPaymentMethod (paymentMethod: IResidentPaymentMethod | number) {
    this.selectedCard = typeof paymentMethod === 'number' ? paymentMethod : paymentMethod.id
    this.$emit('select', paymentMethod)
  }

  closePaymentMethodModal (event: number | null) {
    if (event) {
      this.selectPaymentMethod(event)
    }
    this.wantAddPaymentMethod = false
    this.editPaymentData = null
    this.$forceUpdate()
  }

  openAddPaymentMethodModal () {
    this.wantAddPaymentMethod = true
  }

  async makePrimaryPaymentMethod (id: number) {
    await this.residentModuleInstance.makePaymentMethodPrimary({ residentId: this.residentId, paymentMethodId: id })
  }

  async deletePaymentMethod (id: number) {
    this.deleteErrorMessage = ''
    const response = await this.residentModuleInstance.deletePaymentMethod(id)
    if (response !== 'OK') {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: response.message || 'Something went wrong',
        header: `Delete Payment Method`,
        icon: 'warning'
      })
    } else {
      await this.residentModuleInstance.getResidentPaymentMethods(this.residentId)
      this.$eventBus.$emit('notify', {
        color: 'var(--status-success-color)',
        message: `Payment Method deleted`,
        header: `Delete Payment Method`,
        icon: 'check'
      })
      this.$emit('select', null)
    }
  }

  openEditModal (id: number) {
    this.editPaymentData = this.paymentMethods.find(pm => pm.id === id) || null
    this.wantAddPaymentMethod = true
  }
}
